module.exports = __webpack_public_path__ + "img/02_Explosion_iPad_P.b9faded1.jpg";